import React, { useEffect, useContext } from "react";
import { AppContext } from "../../context";
import ButtonRow from "./ButtonRow";

function AddedToCartInfo({ setIsAddedToCartVisible }) {
  const info = useContext(AppContext);

  return (
    <>
      <div className="ahp-added-to-cart">
        {info.t("reservationAddedToCart")}
      </div>
      <div style={{ padding: "16px 16px 16px 16px", textAlign: "justify" }}>
        {info.t("submitAfterAllReservations")}
      </div>
      <ButtonRow
        btn1Text={info.t("back")}
        btn1Action={() => {
          setIsAddedToCartVisible(false);
          info.setRefresh(!info.refresh);
        }}
        // href1="/"
        btn2Text={info.t("reservationCart")}
        href2="https://aldeiashistoricasdeportugal.com/reservas"
      />
    </>
  );
}

export default AddedToCartInfo;
